import { useState } from 'react';

export default function NewsletterSection() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const formUrl = 'https://readdy.ai/api/form/d9quhksnlsngrm4lm6c0';

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('contact_alt') as string || '').trim();

    if (honeypot) {
      setStatus('success');
      form.reset();
      return;
    }

    try {
      const response = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as any).toString(),
      });
      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore parse errors */ }
      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '';
        setErrorMsg(serverMsg || '订阅失败，请稍后再试');
        setStatus('error');
      }
    } catch {
      setErrorMsg('网络错误，请稍后再试');
      setStatus('error');
    }
  };

  const handleClose = () => {
    setStatus('idle');
    setErrorMsg('');
  };

  return (
    <section className="py-14 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20soft%20dreamy%20background%20with%20scattered%20cute%20warm%20yellow%20butter%20bear%20silhouettes%20and%20floating%20sparkles%2C%20cream%20and%20golden%20pastel%20gradient%2C%20subtle%20star%20patterns%2C%20dreamy%20kawaii%20atmosphere%2C%20soft%20focus%2C%20healing%20vibe&width=1600&height=600&seq=newsletter-bg-2025&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-primary-500/85"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <div className="max-w-xl mx-auto">
          <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-background-50/20 flex items-center justify-center">
            <i className="ri-mail-send-line text-3xl text-background-50"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
            加入小熊通讯录
          </h2>
          <p className="text-sm md:text-base text-background-50/80 mb-8">
            订阅黄油小熊官方资讯，第一时间获取新品发布、限量发售和独家粉丝福利。
          </p>

          <form
            data-readdy-form="newsletter-hero"
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              placeholder="请输入你的邮箱地址"
              className="flex-1 px-5 py-3 rounded-full text-sm bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-background-50/50 transition-all"
              required
            />
            <input
              type="text"
              name="contact_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="spam-guard"
            />
            <button
              type="submit"
              className="px-8 py-3 rounded-full text-sm font-semibold bg-background-50 text-primary-600 hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              免费订阅
            </button>
          </form>
          <p className="text-xs text-background-50/60 mt-4">
            尊重你的隐私，随时可以取消订阅。
          </p>
        </div>
      </div>

      {status !== 'idle' && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="bg-background-50 rounded-2xl p-8 max-w-sm mx-4 text-center shadow-lg">
            {status === 'success' ? (
              <>
                <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-check-line text-3xl text-primary-500"></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">订阅成功！</h3>
                <p className="text-sm text-foreground-500 mb-6">
                  感谢订阅黄油小熊通讯录，最新资讯将第一时间送达你的邮箱~
                </p>
              </>
            ) : (
              <>
                <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-error-warning-line text-3xl text-accent-500"></i>
                </div>
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">订阅失败</h3>
                <p className="text-sm text-foreground-500 mb-6">{errorMsg || '请稍后再试'}</p>
              </>
            )}
            <button
              onClick={handleClose}
              className="px-6 py-2.5 rounded-full text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              知道了
            </button>
          </div>
        </div>
      )}
    </section>
  );
}